import {ccButtonConstants, getValidSize} from '../index';
import computeClassName from '../../../../../utils/computeClassName';
import handleClick from '../../../../../utils/handleClick';
import CCIconClose8x8 from '../../Icon/Close/8x8';
import CCIconClose12x12 from '../../Icon/Close/12x12';

const constants = Object.freeze({
  CLASSNAME_BASE: 'appearance-none inline-flex items-center justify-center rounded-full bg-cc-gray-40 text-cc-primary-contrast',
  CLASSNAME_SIZE: Object.fromEntries(
    new Map([
      [ccButtonConstants.SIZE_MEDIUM,'w-4 h-4'],
      [ccButtonConstants.SIZE_LARGE,'w-5 h-5']
    ])
  ),
  CLASSNAME_IS_DISABLED: {
    true: 'opacity-40',
    false: ''
  },
  ICON_COMPONENT_SIZE: Object.fromEntries(
    new Map([
      [ccButtonConstants.SIZE_MEDIUM, CCIconClose8x8],
      [ccButtonConstants.SIZE_LARGE, CCIconClose12x12]
    ])
  ),
  CLASSNAME_ICON_SIZE: Object.fromEntries(
    new Map([
      [ccButtonConstants.SIZE_MEDIUM, ''],
      [ccButtonConstants.SIZE_LARGE, 'w-2.5 h-2.5']
    ])
  )
});

const propsDefaults = Object.freeze({
  title: 'Clear',
  size: ccButtonConstants.SIZE_MEDIUM,
  isDisabled: false,
  clearFn: null,
});

function getComputedClassName(propsClassName, size, isDisabled) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_SIZE[size]} ${constants.CLASSNAME_IS_DISABLED[isDisabled]}`)
}

function getComputedIconComponent(size) {
  return constants.ICON_COMPONENT_SIZE[size];
}

function getComputedIconClassName(size) {
  return constants.CLASSNAME_ICON_SIZE[size];
}

export default function CCButtonClear(
  {
    title,
    size,
    isDisabled,
    clearFn,
    clearFnArgs,
    className = ''
  }) {
  const validSize = getValidSize(size);
  const validIsDisabled = isDisabled === true;
  const computedClassName = getComputedClassName(className, validSize, validIsDisabled);
  const ComputedIconComponent = getComputedIconComponent(validSize);
  const computedIconClassName = getComputedIconClassName(validSize);

  let dynamicProps = {};
  if (!validIsDisabled && !!clearFn && ('function' === typeof clearFn)) {
    dynamicProps['onClick'] = handleClick(clearFn, clearFnArgs);
  }
  else {
    dynamicProps['disabled'] = true;
    dynamicProps['aria-disabled'] = true;
  }

  return (
    <button type="button"
            aria-label={title}
            title={title}
            className = {computedClassName}
            { ...dynamicProps }>
      <ComputedIconComponent className={computedIconClassName} aria-hidden="true"/>
    </button>
  );
}
